import React, { useState } from 'react';
import cx from 'classnames';
import { CDN_TYPE_SPORT, getCDNUrl } from 'utils';

import { Bus } from '@atlas/core';
import { Flag } from '@atlas/ui';

const CategoryFilterOption = ({
  clickedCategory,
  imagePath,
  onClick,
  option,
  setClickedCategoryId,
}) => {
  const category = option;
  const [active, setActive] = useState(false);

  const mainClassName = cx(
    'sport-filter-option',
    { active },
    { selected: option.id === clickedCategory },
  );

  const onCategoryClick = () => {
    setClickedCategoryId && setClickedCategoryId(category.id);
    onClick && onClick();
    Bus.emit('ui:scroll:content', {
      block: 'center',
      query: `.category[data-cid="${category.id}"]`,
    });

    setActive(true);

    const item = document.querySelector(`.category[data-cid="${category.id}"]`);
    item.classList.add('event-pulse');

    setTimeout(() => {
      setActive(false);
      item.classList.remove('event-pulse');
    }, 2500);
  };

  const name = category.name.length > 18 ? `${category.name.substring(0, 15)}...` : category.name;

  return (
    <div className={mainClassName} onClick={onCategoryClick}>
      <div className="sport-filter-option-icon-container">
        <Flag
          alt={name}
          cdnHostname={getCDNUrl(CDN_TYPE_SPORT)}
          height={12}
          imagePath={imagePath}
          name={category.regionId}
          width={18}
        />
      </div>
      <div className="sport-filter-option-name-container">
        <div className="sport-filter-option-name">{name}</div>
      </div>
    </div>
  );
};

export default CategoryFilterOption;
